module.exports = __webpack_public_path__ + "static/media/settings_black.4d93d874.svg";